export const dataFetching = {
  CURRENT_USER_REQUEST: 'CURRENT_USER_REQUEST',
  CURRENT_USER_SUCCESS: 'CURRENT_USER_SUCCESS',
  CURRENT_USER_ERROR: 'CURRENT_USER_ERROR',
  USERS_REQUEST: 'USERS_REQUEST',
  USERS_REQUEST_SUCCESS: 'USERS_REQUEST_SUCCESS',
  USERS_REQUEST_ERROR: 'USERS_REQUEST_ERROR',
  DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_ERROR: 'DELETE_USER_ERROR',
  CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
  CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
  CREATE_USER_ERROR: 'CREATE_USER_ERROR',
  SIGN_OUT_REQUEST: 'SIGN_OUT_REQUEST',
  SIGN_OUT_REQUEST_SUCCESS: 'SIGN_OUT_REQUEST_SUCCESS',
  SIGN_OUT_REQUEST_ERROR: 'SIGN_OUT_REQUEST_ERROR',
  FILTER_OPTIONS_REQUEST: 'FILTER_OPTIONS_REQUEST',
  FILTER_OPTIONS_REQUEST_SUCCESS: 'FILTER_OPTIONS_REQUEST_SUCCESS',
  FILTER_OPTIONS_REQUEST_ERROR: 'FILTER_OPTIONS_REQUEST_ERROR',
  SAVE_NEW_INFLUENCER_REQUEST: 'SAVE_NEW_INFLUENCER_REQUEST',
  SAVE_NEW_INFLUENCER_REQUEST_SUCCESS: 'SAVE_NEW_INFLUENCER_REQUEST_SUCCESS',
  SAVE_NEW_INFLUENCER_REQUEST_ERROR: 'SAVE_NEW_INFLUENCER_REQUEST_ERROR',
  UPDATE_INFLUENCER_REQUEST: 'UPDATE_INFLUENCER_REQUEST',
  UPDATE_INFLUENCER_SUCCESS: 'UPDATE_INFLUENCER_SUCCESS',
  UPDATE_INFLUENCER_ERROR: 'UPDATE_INFLUENCER_ERROR',
  UPDATE_COLLECTIVE_REQUEST: 'UPDATE_COLLECTIVE_REQUEST',
  UPDATE_COLLECTIVE_SUCCESS: 'UPDATE_COLLECTIVE_SUCCESS',
  UPDATE_COLLECTIVE_ERROR: 'UPDATE_COLLECTIVE_ERROR',
  REMOVE_INFLUENCER_REQUEST: 'REMOVE_INFLUENCER_REQUEST',
  REMOVE_INFLUENCER_REQUEST_SUCCESS: 'REMOVE_INFLUENCER_REQUEST_SUCCESS',
  REMOVE_INFLUENCER_REQUEST_ERROR: 'REMOVE_INFLUENCER_REQUEST_ERROR',
  REMOVE_COLLECTIVE_REQUEST: 'REMOVE_COLLECTIVE_REQUEST',
  REMOVE_COLLECTIVE_SUCCESS: 'REMOVE_COLLECTIVE_SUCCESS',
  REMOVE_COLLECTIVE_ERROR: 'REMOVE_COLLECTIVE_ERROR',
  SAVE_NEW_COLLECTIVE_REQUEST: 'SAVE_NEW_COLLECTIVE_REQUEST',
  SAVE_NEW_COLLECTIVE_REQUEST_SUCCESS: 'SAVE_NEW_COLLECTIVE_REQUEST_SUCCESS',
  SAVE_NEW_COLLECTIVE_REQUEST_ERROR: 'SAVE_NEW_COLLECTIVE_REQUEST_ERROR',
  SEARCH_COLLECTIVE_REQUEST: 'SEARCH_COLLECTIVE_REQUEST',
  SEARCH_COLLECTIVE_REQUEST_SUCCESS: 'SEARCH_COLLECTIVE_REQUEST_SUCCESS',
  SEARCH_COLLECTIVE_REQUEST_ERROR: 'SEARCH_COLLECTIVE_REQUEST_ERROR',
  SAVE_USER_REQUEST: 'SAVE_USER_REQUEST',
  SAVE_USER_REQUEST_SUCCESS: 'SAVE_USER_REQUEST_SUCCESS',
  SAVE_USER_REQUEST_ERROR: 'SAVE_USER_REQUEST_ERROR',
  SEARCH_INFLUENCER_REQUEST: 'SEARCH_INFLUENCER_REQUEST',
  SEARCH_INFLUENCER_REQUEST_SUCCESS: 'SEARCH_INFLUENCER_REQUEST_SUCCESS',
  SEARCH_INFLUENCER_REQUEST_ERROR: 'SEARCH_INFLUENCER_REQUEST_ERROR',
  INFLUENCER_REQUEST: 'INFLUENCER_REQUEST',
  INFLUENCER_REQUEST_SUCCESS: 'INFLUENCER_REQUEST_SUCCESS',
  INFLUENCER_REQUEST_ERROR: 'INFLUENCER_REQUEST_ERROR',
  COLLECTIVE_REQUEST: 'COLLECTIVE_REQUEST',
  COLLECTIVE_REQUEST_SUCCESS: 'COLLECTIVE_REQUEST_SUCCESS',
  COLLECTIVE_REQUEST_ERROR: 'COLLECTIVE_REQUEST_ERROR',
  SEARCH_COLLECTIVES_REQUEST: 'SEARCH_COLLECTIVES_REQUEST',
  SEARCH_COLLECTIVES_REQUEST_SUCCESS: 'SEARCH_COLLECTIVES_REQUEST_SUCCESS',
  SEARCH_COLLECTIVES_REQUEST_ERROR: 'SEARCH_COLLECTIVES_REQUEST_ERROR',
  POLICIES_REQUEST: 'POLICIES_REQUEST',
  POLICIES_REQUEST_SUCCESS: 'POLICIES_REQUEST_SUCCESS',
  POLICIES_REQUEST_ERROR: 'POLICIES_REQUEST_ERROR',
  MEDIA_PLATFORMS_REQUEST: 'MEDIA_PLATFORMS_REQUEST',
  MEDIA_PLATFORMS_REQUEST_SUCCESS: 'MEDIA_PLATFORMS_REQUEST_SUCCESS',
  MEDIA_PLATFORMS_REQUEST_ERROR: 'MEDIA_PLATFORMS_REQUEST_ERROR',
  GENERATE_INFLUENCER_REPORT_REQUEST: 'GENERATE_INFLUENCER_REPORT',
  GENERATE_INFLUENCER_REPORT_REQUEST_SUCCESS: 'GENERATE_INFLUENCER_REPORT_SUCCESS',
  GENERATE_INFLUENCER_REPORT_REQUEST_ERROR: 'GENERATE_INFLUENCER_REPORT_ERROR',
  GENERATE_COLLECTIVE_REPORT_REQUEST: 'GENERATE_COLLECTIVE_REPORT',
  GENERATE_COLLECTIVE_REPORT_REQUEST_SUCCESS: 'GENERATE_COLLECTIVE_REPORT_SUCCESS',
  GENERATE_COLLECTIVE_REPORT_REQUEST_ERROR: 'GENERATE_COLLECTIVE_REPORT_ERROR',
  FETCH_INITIAL_DATA_REQUEST: 'FETCH_INITIAL_DATA_REQUEST',
  FETCH_INITIAL_DATA_SUCCESS: 'FETCH_INITIAL_DATA_SUCCESS',
  FETCH_INITIAL_DATA_ERROR: 'FETCH_INITIAL_DATA_ERROR',
};

export const errors = {
  CLEAR_LAST_ERROR_MESSAGE: 'CLEAR_LAST_ERROR_MESSAGE',
  ADD_MESSAGE: 'ERROR_ADD_MESSAGE',
};

export const users = {
  REQUEST_EDIT_USER: 'REQUEST_EDIT_USER',
  CANCEL_EDIT_USER: 'CANCEL_EDIT_USER',
  REQUEST_ADD_USER: 'REQUEST_ADD_USER',
  CANCEL_ADD_USER: 'CANCEL_ADD_USER',
  CHANGE_NEW_USER_ATTRIBUTE: 'CHANGE_NEW_USER_ATTRIBUTE',
};

export const influencers = {
  REQUEST_VIEW_INFLUENCER: 'REQUEST_VIEW_INFLUENCER',
  CANCEL_VIEW_INFLUENCER: 'CANCEL_VIEW_INFLUENCER',
  MAIL_INFLUENCER_SEARCH_RESULTS: 'MAIL_INFLUENCER_SEARCH_RESULTS',
  NEXT_PAGE_REQUEST: 'INFLUENCER_NEXT_PAGE_REQUEST',
  NEXT_PAGE_SUCCESS: 'INFLUENCER_NEXT_PAGE_SUCCESS',
  NEXT_PAGE_ERROR: 'INFLUENCER_NEXT_PAGE_ERROR',
  FILTER_RESULTS_REQUEST: 'INFLUENCER_FILTER_RESULTS_REQUEST',
  FILTER_RESULTS_SUCCESS: 'INFLUENCER_FILTER_RESULTS_SUCCESS',
  FILTER_RESULTS_ERROR: 'INFLUENCER_FILTER_RESULTS_ERROR',
  REQUEST_IMPORT: 'INFLUENCER_REQUEST_IMPORT',
  REQUEST_IMPORT_ERROR: 'INFLUENCER_REQUEST_IMPORT_ERROR',
  RESET_REPORT_BUTTON: 'INFLUENCER_RESET_REPORT_BUTTON',
};

export const collectives = {
  NEXT_PAGE_REQUEST: 'COLLECTIVE_NEXT_PAGE_REQUEST',
  NEXT_PAGE_SUCCESS: 'COLLECTIVE_NEXT_PAGE_SUCCESS',
  NEXT_PAGE_ERROR: 'COLLECTIVE_NEXT_PAGE_ERROR',
  FILTER_RESULTS_REQUEST: 'COLLECTIVE_FILTER_RESULTS_REQUEST',
  FILTER_RESULTS_SUCCESS: 'COLLECTIVE_FILTER_RESULTS_SUCCESS',
  FILTER_RESULTS_ERROR: 'COLLECTIVE_FILTER_RESULTS_ERROR',
  SINGLE_REQUEST: 'COLLECTIVE_SINGLE_REQUEST',
  SINGLE_SUCCESS: 'COLLECTIVE_SINGLE_SUCCESS',
  SINGLE_ERROR: 'COLLECTIVE_SINGLE_ERROR',
  NEW_COLLECTIVES_SUCCESS: 'NEW_COLLECTIVES_SUCCESS',
  MERGE_DIALOG_REQUEST: 'COLLECTIVE_MERGE_DIALOG_REQUEST',
  MERGE_DIALOG_CANCEL: 'COLLECTIVE_MERGE_DIALOG_CANCEL',
  SET_MERGE_INTO: 'COLLECTIVE_SET_MERGE_INTO',
  CLEAR_ALL: 'COLLECTIVE_CLEAR_ALL',
  RESET_REPORT_BUTTON: 'COLLECTIVE_RESET_REPORT_BUTTON',
  SET_ACTIVE: 'COLLECTIVE_SET_ACTIVE',
};

export const location = {
  LOCATION_CHANGE: 'LOCATION_CHANGE',
  LOCATION_CHANGE_COMPLETE: 'LOCATION_CHANGE_COMPLETE',
  LOCATION_REQUEST: 'LOCATION_REQUEST',
  LOCATION_REQUEST_CLEAR: 'LOCATION_REQUEST_CLEAR',
  LOCATION_OPTIONS_CLEAR: 'LOCATION_OPTIONS_CLEAR',
};

export const activeFilters = {
  SET_ACTIVE_FILTER: 'SET_ACTIVE_FILTER',
  CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
  SET_SEARCH_TERM: 'ACTIVE_FILTERS_SET_SEARCH_TERM',
  SET_SEARCH_CITY: 'ACTIVE_FILTERS_SET_SEARCH_CITY',
  SET_SEARCH_STATE: 'ACTIVE_FILTERS_SET_SEARCH_STATE',
  SET_SORT_ORDER: 'ACTIVE_FILTERS_SET_SORT_ORDER',
};

export const view = {
  TOGGLE_ACTIVE_VIEW: 'TOGGLE_ACTIVE_VIEW',
  REQUEST_TAB_CHANGE: 'VIEW_REQUEST_TAB_CHANGE',
  INCREMENT_PAGE: 'VIEW_INCREMENT_PAGE',
};

export default {
  dataFetching,
  users,
  errors,
  location,
  activeFilters,
  influencers,
  collectives,
  view,
};



/** WEBPACK FOOTER **
 ** ./constants/actionTypes.js
 **/